import {useQuery} from 'react-query';
import {toast} from 'react-toastify';
import {CashPaymentResponse} from '../../../pages/shopping-basket/cash-payment/utils/types';
import {getOrderCashTransactionPrice} from './getOrderCashTransactionPrice';

const useGetOrderCashTransactionPrice = ({
  orderGuid,
  handleAfterSuccess,
  enabled = true,
}: {
  orderGuid?: string;
  handleAfterSuccess?: (data: CashPaymentResponse) => void;
  enabled?: boolean;
}) => {
  const {data, isLoading, refetch, isSuccess, isFetching} =
    useQuery<CashPaymentResponse>(
      ['get-order-cash-transaction-price', orderGuid],
      () => getOrderCashTransactionPrice(orderGuid),
      {
        enabled: Boolean(orderGuid) && enabled,
        onSuccess: data => handleAfterSuccess?.(data),
        onError: (error: any) => {
          toast.error(
            error?.response?.data?.message ||
              'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
          );
        },
      },
    );
  return {data, isLoading, refetch, isSuccess, isFetching};
};

export default useGetOrderCashTransactionPrice;
